<template>
  <redoc-wrapper :spec="spec"/>
</template>

<script>
import RedocWrapper from '../../components/redoc-wrapper/redoc-wrapper.vue';
import { getSpec } from './spec';

export default {
  name: 'api',
  components: {
    RedocWrapper,
  },
  data() {
    return {
      spec: null,
    };
  },
  methods: {
    async loadSpec(version) {
      if (this.$root.branding) {
        this.spec = await getSpec(this.$route.meta.apiType, version, this.$root.branding);
        return;
      }

      // If the branding hasn't been loaded yet, watch it until it is.
      const stopWatch = this.$watch('$root.branding', async () => {
        if (!this.$root.branding) return;

        this.spec = await getSpec(this.$route.meta.apiType, this.$route.params.version, this.$root.branding);

        return stopWatch();
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    return next(vm => vm.loadSpec(to.params.version));
  },
  beforeRouteUpdate(to, from) {
    return this.loadSpec(to.params.version);
  }
};
</script>
